import { useEffect } from 'react'

export default function useDocumentEvents(events: string[], callback: any): void {
  return useEffect(() => {
    events.forEach((event) => {
      document.addEventListener(event, callback)
    })

    return () => {
      events.forEach((event) => {
        document.removeEventListener(event, callback)
      })
    }
  }, [events, callback])
}
